module.exports = __webpack_public_path__ + "img/nolan-drafting-compass.4588ef8b.svg";